export var STORAGE_NAME_AUTH = 'auth';
